<template>
  <div class="circle-progress">
    <canvas ref="progress" class="progress"></canvas>
    <div class="num-progress" v-show="show_finished_num !== all_num"><span class="done">{{show_finished_num}}</span> / {{all_num}}</div>
    <img-v3 :src="require('../../images/finished.png')" alt="" class="finished-icon" v-show="show_finished_num === all_num" />
  </div>
</template>
<script>
  export default {
    props: ["progress", "is_finished"],
    data() {
      return {
        currentProgress: 0,
        show_finished_num: 0,
        show_finished_icon: false
      }
    },
    computed: {
      finished_num() {
        return this.progress.finished_num || 0
      },
      all_num() {
        return this.progress.all_num || 0
      }
    },
    created() {
      this.show_finished_num = this.finished_num - 1;
    },
    mounted(){
      this.initBgCircle()
    },
    methods: {
      initBgCircle() {
        // const maxPro = 100
        // const progress = 40
        const r = 60;
        const cvs = this.$refs.progress;
        cvs.width = 320
        cvs.height = 320
        const ctx = cvs.getContext('2d');
        ctx.scale(2,2)

        ctx.lineWidth = 20
        ctx.strokeStyle = this.progress.bg_color || 'rgba(197,206,218,0.30)';
        ctx.arc(r + 20, r + 20, r, 0, 2 * Math.PI)
        ctx.stroke()
        window.requestAnimationFrame(() => {this.renderProgress()});

        // ctx.beginPath()
        // ctx.lineCap = 'round'
        // // 下面是渐变的代码不需要的可以换成纯色
        // ctx.strokeStyle = '#FFDC14'
        // const startRadian = this.currentProgress >= maxPro ? 0 : Math.PI * 1.5
        // const rate = this.currentProgress / maxPro
        // const endRadian = this.currentProgress >= maxPro ? 2 * Math.PI : 2 * Math.PI * rate - Math.PI / 2
        // ctx.arc(r + 20, r + 20, r, startRadian, endRadian)
        // ctx.stroke()
      },
      renderProgress() {
        let finished_num = this.finished_num,
            all_num = this.all_num;
        let progress = all_num === 0 ? 0 : Math.floor(finished_num / all_num * 100)
        const maxPro = 100;
        const r = 60;
        const cvs = this.$refs.progress;
        const ctx = cvs.getContext('2d');
        // ctx.scale(2,2)

        if (progress === 0) {
          return
        }
        if (this.currentProgress < progress) {
          this.currentProgress++
          window.requestAnimationFrame(() => {this.renderProgress()});
        } else {
          this.show_finished_num = this.show_finished_num + 1;
          if (this.is_finished) {
            this.$emit('updateStatus')
            setTimeout(() => {
              this.show_finished_icon = true;
              this.$router.replace({ name: "home" });
            }, 1000)
          }


        }

        ctx.beginPath();
        ctx.lineCap = 'round'
        ctx.strokeStyle = this.progress.progress_color || '#FFDC14'
        const startRadian = this.currentProgress >= maxPro ? 0 : Math.PI * 1.5
        const rate = this.currentProgress / maxPro
        const endRadian = this.currentProgress >= maxPro ? 2 * Math.PI : 2 * Math.PI * rate - Math.PI / 2
        ctx.arc(r + 20, r + 20, r, startRadian, endRadian)

        ctx.stroke()
      }
    }
  }
</script>
<style lang="scss" scoped>
.circle-progress {
  position: relative;
  width: 100%;
  height: 100%;
  .progress {
    zoom: 0.5
  }
  .num-progress,
  .finished-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .num-progress {
    font-size: .28rem;
    color: #91A0B4;
    .done {
      font-size: .8rem;
      color: #404250;
    }
  }
  .finished-icon {
    width: .7rem;
    height: .7rem;
  }
}
</style>

